import { render, staticRenderFns } from "./SummaryTotalBudget.vue?vue&type=template&id=34aac032&scoped=true"
import script from "./SummaryTotalBudget.vue?vue&type=script&lang=js"
export * from "./SummaryTotalBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aac032",
  null
  
)

export default component.exports